package kz.dentalcrm.app.core.ui.components.refresh

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.size
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import kz.dentalcrm.app.theme.DefaultTheme

@Composable
fun PullToRefreshIndicator(
    state: PullToRefreshState,
    refreshTriggerDistance: Dp,
    refreshingOffset: Dp,
    modifier: Modifier = Modifier,
//    textStyle: TextStyle = TextStyle.Default.copy(color = Color.Gray, fontSize = 14.sp),
) {
//    val refreshTriggerPx = with(LocalDensity.current) { refreshTriggerDistance.toPx() }
    val refreshingOffsetPx = with(LocalDensity.current) { refreshingOffset.toPx() }
    val indicatorHeight = 48.dp
    val indicatorHeightPx = with(LocalDensity.current) { indicatorHeight.toPx() }
    Row(
        modifier = modifier
            .fillMaxWidth()
            .height(indicatorHeight)
//            .padding(end = 26.dp)
            .graphicsLayer {
                translationY = state.contentOffset - (refreshingOffsetPx + indicatorHeightPx) / 2
            },
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically
    ) {
        CircularProgressIndicator(
            color = DefaultTheme.colors.primary,
            modifier = Modifier.size(24.dp),
            strokeWidth = 3.dp
        )

//        if (state.isRefreshing) {
//            val transition = rememberInfiniteTransition(label = "infinite")
//            val progress by transition.animateValue(
//                0f,
//                1f,
//                Float.VectorConverter,
//                infiniteRepeatable(
//                    animation = tween(
//                        durationMillis = 1332, // 1 and 1/3 second
//                        easing = LinearEasing
//                    )
//                ),
//                label = "progress"
//            )
//            Image(
//                painter = painterResource(id = UIDrawable.ic_common_plus),
//                contentDescription = "refreshing",
//                modifier = Modifier
//                    .padding(end = 8.dp)
//                    .size(18.dp)
//                    .rotate(progress * 360),
//                colorFilter = ColorFilter.tint(textStyle.color)
//            )
//        } else {
//            val progress = ((state.contentOffset - refreshTriggerPx / 2) / refreshTriggerPx * 2)
//                .coerceIn(0f, 1f)
//            Image(
//                painter = painterResource(id = UIDrawable.ic_phone_input_arrow_down),
//                contentDescription = "pull to refresh",
//                modifier = Modifier
//                    .padding(end = 8.dp)
//                    .size(18.dp)
//                    .rotate(progress * 180),
//                colorFilter = ColorFilter.tint(textStyle.color)
//            )
//        }
//        BasicText(
//            text = when {
//                state.isPullInProgress && state.contentOffset >= refreshTriggerPx -> "Обновляем"
//                state.isRefreshing -> "Обновляем"
//                else -> "Обновляем"
//            },
//            style = textStyle
//        )
    }
}